// extracted by mini-css-extract-plugin
module.exports = {"posts":"postlist-module--posts--2kmDk","nav":"postlist-module--nav--1Puv7","center":"postlist-module--center--3kEXt"};